import memberToUser from '../services/member-user-mapper';
import { createUser } from './create-user';

export const loginMember = (member) => createUser(memberToUser(member));
